// After an update, a page that stayed open (a phone keeps Studio open for days) asks for files the update replaced,
// and Safari says "Importing a module script failed". Vite reports that as vite:preloadError: load the new version
// once instead. Once per minute at most, so a file that's really missing can't loop the page.
const KEY = "vera-reloaded-for-update";

type Win = Pick<Window, "addEventListener"> & { location: Pick<Location, "reload"> };

export function reloadOnNewVersion(win: Win, storage: Pick<Storage, "getItem" | "setItem">, now = () => Date.now()) {
  win.addEventListener("vite:preloadError", (event) => {
    let last = 0;
    try { last = Number(storage.getItem(KEY) ?? 0); } catch { /* private mode: still reload once */ }
    if (now() - last < 60_000) return; // just reloaded: let the error show
    try { storage.setItem(KEY, String(now())); } catch { /* see above */ }
    event.preventDefault();
    win.location.reload();
  });
}
